export default {"src":"/_next/static/media/logo-stamp.10417ebd.svg","height":150,"width":150,"blurWidth":0,"blurHeight":0};